import StoryAPI from '@/api/story';
import cloneDeep from 'lodash/cloneDeep';
import store from '../../store';

// initial state
const state = () => ({
  all: [],
  seek: null,
  data: null,
  ip: null,
  profile: { firstName: '', lastName: '' },
  actionReward: null,
  lastPlayedEpisodeId: null
});

// getters
const getters = {
  all: (state) => state.all,
  seek: (state) => state.seek,
  get: (state) => state.data,
  getIp: (state) => state.ip,
  getProfile: (state) => state.profile,
  actionReward: (state) => state.actionReward,
  lastPlayedEpisodeId: (state) => state.lastPlayedEpisodeId
};

// actions
const actions = {
  async list({ state, commit }, payload = null) {
    try {
      const res = await StoryAPI.list(payload);
      if (res) {
        commit('setList', res.data);
      }
    } catch (e) {
      throw e;
    }
  },
  async add({ state, commit }, payload = null) {
    try {
      const res = await StoryAPI.list(payload);
      if (res) {
        commit('addList', res.data);
      }
    } catch (e) {
      throw e;
    }
  },
  async get({ state, commit }, payload) {
    if (payload) {
      try {
        const res = await StoryAPI.get(payload);
        if (res) {
          commit('setData', res.data);
        }
      } catch (e) {
        throw e;
      }
    } else {
      commit('setData', null);
    }
  },
  async getIp({ state, commit }, ipId) {
    if (ipId) {
      try {
        const res = await StoryAPI.getIp(ipId);
        if (res) {
          commit('setIp', res.data);
        }
      } catch (e) {
        throw e;
      }
    } else {
      commit('setIp', null);
    }
  },
  async purchase({ commit, rootGetters }, payload) {
    if (!rootGetters['auth/isLogin']) return;

    try {
      const res = await StoryAPI.purchase(payload);
      commit('updateData', { payload: payload, res: res.data });
    } catch (e) {
      throw e;
    }
  },
  async postIp({ state, commit, rootGetters }, payload) {
    if (!rootGetters['auth/isLogin']) {
      commit('setProfile', payload);
      return;
    }

    try {
      await StoryAPI.postIp(payload);
      await store.dispatch('story/getIp', payload.ipId);
    } catch (e) {
      throw e;
    }
  },
  reset({ commit }) {
    commit('reset');
  },
  resetActionReward({ commit }) {
    commit('resetActionReward');
  },
  setLastPlayedEpisodeId({ commit }, id) {
    commit('setLastPlayedEpisodeId', id);
  }
};

const mutations = {
  setList(state, data) {
    state.all = data.list;
    state.seek = data.seek;
  },
  addList(state, data) {
    const all = cloneDeep(state.all);
    all.push(...data.list);
    state.all = all;
    state.seek = data.seek;
  },
  updateData(state, data) {
    const index = state.data.episodeList.findIndex((story) => story.storyEpisodeId === data.payload.story.storyEpisodeId);
    if (index >= 0) {
      const all = cloneDeep(state.data.episodeList);
      if (data.payload.story.badge === 'PURCHASE') {
        all[index].badge = 'PURCHASED';
      } else {
        if (data.payload.isCharging) {
          all[index].badge = 'CHARGED';
        } else {
          all[index].badge = 'PURCHASED';
        }
      }
      state.data.episodeList = all;
      state.actionReward = data.res.actionReward;
    }
  },
  setData(state, data) {
    state.data = data;
  },
  setProfile(state, data) {
    state.profile = { firstName: data.firstName || state.profile.firstName || '', lastName: data.lastName || state.profile.lastName || '' };
  },
  setIp(state, data) {
    state.ip = data;
    state.profile = { firstName: data.firstName || state.profile.firstName || '', lastName: data.lastName || state.profile.lastName || '' };
  },
  reset(state) {
    state.all = [];
    state.seek = null;
    state.data = null;
    state.ip = null;
  },
  resetActionReward(state) {
    state.actionReward = null;
  },
  setLastPlayedEpisodeId(state, id) {
    state.lastPlayedEpisodeId = id;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
